import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "trucks",
    pageTitle: "Trucks",
    columns,
    searchFields,
    searchPlaceholder: "e.g. truckType:jumbo, model:bmw, year:2004, or plateNumber:tx2020",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
